/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedBottomModuleContent_bottomModule = ReadonlyArray<{
    readonly title: string | null;
    readonly description: string | null;
    readonly " $refType": "SharedBottomModuleContent_bottomModule";
}>;
export type SharedBottomModuleContent_bottomModule$data = SharedBottomModuleContent_bottomModule;
export type SharedBottomModuleContent_bottomModule$key = ReadonlyArray<{
    readonly " $data"?: SharedBottomModuleContent_bottomModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedBottomModuleContent_bottomModule">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedBottomModuleContent_bottomModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "BottomModule",
  "abstractKey": null
};
(node as any).hash = '5c394bfcb2e03f15abfc2623193c3bac';
export default node;
